(function () {
  'use strict';

  var ENDPOINT = '/apps/plant-x-me/api/pdf/guide';

  function textOf(root, selectors, fallback) {
    for (var index = 0; index < selectors.length; index += 1) {
      var node = root.querySelector(selectors[index]);
      if (node && node.textContent.trim()) return node.textContent.trim();
    }
    return fallback;
  }

  function prepareArticle(article) {
    var clone = article.cloneNode(true);
    clone.querySelectorAll('script, style, nav, dialog, [data-pxm-download-guide], [data-pxm-mark-read], [data-pxm-reader-favorite], [data-pxm-depth-tabs], [data-pxm-related-guide]').forEach(function (node) {
      node.remove();
    });
    clone.querySelectorAll('[hidden]').forEach(function (node) {
      node.removeAttribute('hidden');
    });
    clone.querySelectorAll('button').forEach(function (button) {
      var replacement = document.createElement('span');
      replacement.textContent = button.textContent;
      replacement.className = button.className;
      button.replaceWith(replacement);
    });
    clone.querySelectorAll('img').forEach(function (image) {
      var source = image.currentSrc || image.getAttribute('src');
      if (!source) return;
      try {
        image.setAttribute('src', new URL(source, window.location.href).href);
      } catch (_) {
        image.remove();
      }
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.setAttribute('loading', 'eager');
    });
    return clone;
  }

  function filenameFrom(response, fallback) {
    var disposition = response.headers.get('content-disposition') || '';
    var match = disposition.match(/filename="([^"]+)"/i);
    return match ? match[1] : fallback;
  }

  async function download(article) {
    if (!article) throw new Error('Fiche introuvable.');
    var clone = prepareArticle(article);
    var guideId = article.dataset.guideId || 'fiche';
    var title = textOf(clone, ['h1', 'h2', '.pxm-reader-title'], 'Fiche Plant x Me');
    var category = textOf(clone, ['.pxm-resource-meta', '.pxm-layer-label', '.pxm-reader-eyebrow'], 'Fiche pratique');
    var sourceUrl = window.location.origin + window.location.pathname + window.location.search + '#guide-' + encodeURIComponent(guideId);
    var response = await fetch(ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/pdf' },
      body: JSON.stringify({
        guideId: guideId,
        title: title,
        category: category,
        sourceUrl: sourceUrl,
        html: clone.outerHTML
      })
    });
    if (!response.ok) {
      var message = 'La création du PDF est momentanément indisponible.';
      try {
        var error = await response.json();
        if (error && error.error) message = error.error;
      } catch (_) {}
      throw new Error(message);
    }
    var contentType = response.headers.get('content-type') || '';
    if (contentType.indexOf('application/pdf') === -1) throw new Error('Le fichier reçu est invalide.');
    var blob = await response.blob();
    var objectUrl = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = objectUrl;
    link.download = filenameFrom(response, 'plant-x-me-' + guideId + '.pdf');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 30_000);
  }

  window.PxmGuidePdf = { download: download };
})();
